const organisationNameRegex = /^[\w (),-]*$/;

export default organisationNameRegex;
